import DocumentTags from './DocumentTags';

export default DocumentTags;
